import Modal from 'bootstrap/js/dist/modal';

const inBackend = document.body.classList.contains('neos-backend');


document.querySelectorAll('.reference').forEach((reference) => {

    if (inBackend) return;

    const modalElement = reference.querySelector('.reference-modal');
    if (!modalElement) return;

    const modal = new Modal(modalElement);

    reference.querySelectorAll('.reference-modal-link').forEach((modalLink) => {
        modalLink.addEventListener('click', (event) => {
            event.preventDefault();
            modal.show();
        });
    });

    reference.querySelectorAll('.reference-modal-slider-close-icon').forEach((modalClose) => {
        modalClose.addEventListener('click', () => modal.hide());
    });

});
